<template>
    <section>
        <form @submit.prevent="regist()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1663')}}
            <!-- 개인정보 입력 -->
        </div>
        <div class="t-body3 mt6 t-color-bodyGrayA">
            {{$t('1664')}}
            <!-- 매장을 선택하세요. -->
        </div>
        <div class="mt38">
            
            <!-- <div class="mdc-select mdc-select--outlined w-full" 
                :class="submitState && storeInvalidCheck ? 'mdc-select--invalid' : ''"
                id="storeEl"
            
            > -->
            <div class="mdc-select mdc-select--outlined w-full" 
                id="storeEl"
            
            >
                <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                <select class="mdc-select__native-control" name="store" v-model="store" v-validate="'required'" @change="SET_STORE(store)">
                    <option  value="">
                        {{$t('1665')}}
                        <!-- 매장선택 -->
                    </option>
                    <option  v-for="store in storeList" :key="store.value" :value="store.value">
                        {{store.text}}
                    </option>
                </select>
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                        <!-- <label class="mdc-floating-label"></label> -->
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
            </div>
            <!-- <div class="t-helper text-helper warning">
                <span v-show="submitState && storeInvalidCheck">* 매장을 선택하세요.</span>
            </div> -->
            
        </div>
        <div class="mt26 mb19">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1666')}}
                <!-- 회원가입 -->
            </button>
            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="cancelJoin()" @keypress="cancelJoin()" type="button" tabindex="0">
                {{$t('1667')}}
                <!-- 취소 -->
            </button>
        </div>

        
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언 S
import {MDCSelect} from '@material/select'
import {MDCRipple} from '@material/ripple'


// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            store: '',
            storeList: {},
            submitState: false,
            storeSelect: null
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // email 유효성 Check 및 아이콘
        storeInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('store')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }

            this.storeSelect.valid === !returnValue ? '' : this.storeSelect.valid = !returnValue
            return returnValue
        }

    },

    created() {
        if (
                !this.join.role || !this.join.responsibility || 
                !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || 
                !this.join.name.last || !this.join.loginId || !this.join.loginPw
            ) {
            // this.$router.go(-1)
        }
    },

    mounted() {
        this.setMaterialUi()
        this.fetchData()
        // this.$refs.email.focus()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE']),

        
        fetchData() {
            joinApi.store().then((response) => {
                this.storeList = response.data.data

                this.storeSelect = new MDCSelect(document.querySelector('#storeEl'))
                const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                    let button = new MDCRipple.attachTo(el)
                    return button
                })

                this.store = this.join.store
                this.storeSelect = this.store
            }).catch((err) => {
                
            })
        },

        // 회원가입 API 호출
        regist() {

            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_STORE(this.store)

                    let params = this.join
                    let responseData = null

                    joinApi.register(params).then((response) => {
                        this.$router.push({name: 'JoinComplete'})
                    }).catch((err) => {
                        responseData = err.response.data.meta
                        this.$error({content: responseData.errMsg}).then(() => {
                            this.$router.push('/login')
                        })
                    })        
                } else{
                    // this.focusFirstInvalidElement()
                    this.$snackOpen({
                        contents: this.$t('947'), //매장을 선택하세요.
                        btnDisplay: ''
                    }).then(() => {})
                }
            })

            
        },

    },
    setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    

}
</script>

<style scoped>

</style>
